import {
  Box,
  Grid,
  ListItemButton,
  Typography,
} from "@mui/material";
import React from "react";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import PublicIcon from "@mui/icons-material/Public";
import PublicOffIcon from "@mui/icons-material/PublicOff";
import { CardImageComponent } from "../../Component/Component";
import { PROJECTS, UPCOMMING } from "../../Constant/constant";
const images = [
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://images8.alphacoders.com/877/877849.jpg",
    status: "Public",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
    status: "Private",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://img.youtube.com/vi/KT7BwOCUXwY/maxresdefault.jpg",
    status: "Public",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://www.esrb.org/wp-content/uploads/2018/09/19BR_ESRB_ParentGuide_ESRB_ParentGuide_1920x1080_v2-1024x576.jpg",
    status: "Private",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://images6.alphacoders.com/934/934290.jpg",
    status: "Public",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://cdn.images.express.co.uk/img/dynamic/143/590x/Fortnite-907210.jpg",
    status: "Public",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://media.criticalhit.net/2018/05/BRVS.jpg",
    status: "Private",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://images8.alphacoders.com/877/877849.jpg",
    status: "Public",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
    status: "Private",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://img.youtube.com/vi/KT7BwOCUXwY/maxresdefault.jpg",
    status: "Public",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://www.esrb.org/wp-content/uploads/2018/09/19BR_ESRB_ParentGuide_ESRB_ParentGuide_1920x1080_v2-1024x576.jpg",
    status: "Private",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://images6.alphacoders.com/934/934290.jpg",
    status: "Public",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://cdn.images.express.co.uk/img/dynamic/143/590x/Fortnite-907210.jpg",
    status: "Public",
    project: "Coming Soon",
  },
  {
    label: "Fortnite Battle Royale",
    imgPath:
      "https://media.criticalhit.net/2018/05/BRVS.jpg",
    status: "Private",
    project: "Coming Soon",
  },
];
const UpcommingProject = () => {
  return (
    <Grid container className="upcomming-project-Grid" spacing={2}>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        className="upcomming-project-text-container"
      >
        <Typography variant="h5" className="upcomming-project-text-header">
          {UPCOMMING} &nbsp;
          <span style={{ color: "white" }}>{PROJECTS}</span>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container spacing={3}>
      {images?.map((image, index) => {
        return (
          <Grid item xs={6} sm={6} md={3} lg={3} xl={3} key={index}>
              <CardImageComponent className="upcomming-project-card">
                <img className="cursor-pointer" src={image?.imgPath} alt={image?.label} />
              </CardImageComponent>
              <Typography
                variant="caption"
                className="upcomming-project-caption"
              >
                {image?.project}
              </Typography>
              <Box>
              <Grid container sx={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                  <Typography
                    variant="caption"
                    className="upcomming-project-text"
                  >
                    {(image?.label.toUpperCase())}
                  </Typography>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                  <ListItemButton>
                    <ArrowCircleRightOutlinedIcon className="upcomming-project-btn" />
                  </ListItemButton>
                </Grid>
                <Grid item xs={10} sm={10} md={10} lg={10} xl={10} className="upcomming-project-status-grid">
                  <>
                    {image?.status === "Public" ? (
                      <PublicIcon className="upcomming-project-text-status-public-btn" />
                    ) : (
                      <PublicOffIcon className="upcomming-project-text-status-private-btn" />
                    )}
                    <Typography
                      variant="caption"
                      className="upcomming-project-text-status"
                    >
                      {image?.status.toUpperCase()}
                    </Typography>
                  </>
                </Grid>
              </Grid>
              </Box>
              
          </Grid>
        );
      })}
      </Grid>
      </Grid>
      {/* <Grid item lg={12} className="upcomming-project-loadmore-btn">
        {next < images?.length && (
          <Button onClick={handleMoreImage}>Load more</Button>
        )}
      </Grid> */}
    </Grid>
  );
};

export default UpcommingProject;
